<header>

  <mat-toolbar>
    <img class="logo" (click)="route('')" />
    <span class="toolbarMiddleSpace"></span>
    <button mat-button [matMenuTriggerFor]="langMenu">
      {{Language}}
    </button>
    <button mat-button *ngIf="authService.isLoggedIn()" [matMenuTriggerFor]="userMenu">
      <mat-icon>person</mat-icon>
    </button>
  </mat-toolbar>


  <mat-menu #userMenu="matMenu">
    <button mat-menu-item (click)="route('currentUser')" *ngIf="user">
      {{user.NAME}} {{user.SURNAME}}
    </button>
    <button mat-menu-item (click)="route('gipUserChangePwd')">
      {{'CHANGEPASSWORD' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
    </button>
    <button mat-menu-item (click)="logout()">
      {{'SID_Logout' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "SIDEBAR"}}
    </button>
  </mat-menu>


  <mat-menu #langMenu="matMenu">
    <button mat-menu-item (click)="setLanguage('EN')">EN</button>
    <button mat-menu-item (click)="setLanguage('DE')">DE</button>
  </mat-menu>
</header>
